import { HttpClient } from './serviceBase';
import { utils } from '../utils/utils'

class SellerService {
    Search = async (pageSize, pageNumber, textField, businessId, active = true) => {
        const queryString = utils.GetQueryStringsFromObject({ 
            textField,
            pageSize, 
            pageNumber,
            active,
            businessId
        })
        return await HttpClient.Get(`/api/sellers/search?${queryString}`);
    }
}

export default new SellerService();